import { createApp } from 'vue';
import Welcome from './welcome';
import { BrowserDetect } from '@/utils/getBrowser';
import { message, Modal } from 'ant-design-vue';
import { ISWELCOME } from '@/hooks/auth/index';
import icon_download from '@/assets/images/icon_sownload.png';
import logo_chrome from '@/assets/images/logo_chrome.png';
const welcomeModel = (): void => {
  const mountNode = document.createElement('div');
  mountNode.id = 'first-login-welcome-model';

  const Instance = createApp(Welcome, {
    close: () => {
      Instance.unmount();
      document.body.removeChild(mountNode);
      localStorage.removeItem(ISWELCOME);
      BrowserDetect.init();
      if (BrowserDetect.browser !== 'Chrome' || BrowserDetect.version < 100) {
        Modal.confirm({
          class: 'browser',
          okText: (
            <a download={'chrome.exe'} href="https://res.xiwang.com/chrome/chrome_installer_110.exe">
              下载 <span class="iconfont icon-icon_download" style={{ verticalAlign: 'top' }}></span>
            </a>
          ),
          cancelText: null,
          closable: true,
          title: <h2 style={{ textAlign: 'center' }}>发现更好的使用体验</h2>,
          content: (
            <p>
              <span>推荐下载安装最新版本</span> <img style={{ width: '16px', display: 'inline', marginTop: '-3px' }} src={logo_chrome} alt="" />
              <span>chrome获得更良好的使用体验</span>{' '}
            </p>
          ),
          icon: null,
          onOk: () => {}
        });
      }
    }
  });

  document.body.appendChild(mountNode);
  Instance.mount(mountNode);
};

export default welcomeModel;
